import London from "./protocols/London"
import None from "./protocols/None";
import Xilica from "./protocols/Xilica";
import Yamaha from "./protocols/Yamaha";
import QsysNamedControl from "./protocols/QsysNamedControl";

const getProtocol = (processorType) => {
    switch (processorType) {
        case 'LONDON':
            return London;
        case 'XILICA':
            return Xilica;
        case 'YAMAHA':
            return Yamaha;
        case 'QSYS_NAMED_CONTROL':
            return QsysNamedControl;
        default:
            return None;
    }
}

export {
    getProtocol
}